import * as React from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from "reactstrap";

import Loader from "../Loader/DotLoader";

import "./index.css";

interface IProps {
  modal: boolean;
  loading: boolean;
  title: string;
  toggleModal(): void;
  handleResponse(e: React.FormEvent<HTMLInputElement>): void;
}

const DialogModal: React.SFC<IProps> = props => {
  return (
    <div>
      <Modal isOpen={props.modal} toggle={props.toggleModal}>
        <ModalHeader toggle={props.toggleModal} />
        <ModalBody>
          <p style={{ textAlign: "center" }}>{props.title}</p>
          {props.loading ? (
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={12} md={12} lg={12} className="center-align">
                <Loader />
              </Col>
            </Row>
          ) : (
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={12} md={6} lg={6} className="center-align">
                <Button onClick={(e: any) => props.handleResponse(e)}>
                  Yes
                </Button>
              </Col>
              <Col xs={12} md={6} lg={6} className="center-align">
                <Button onClick={props.toggleModal} className="secondary-btn">
                  No
                </Button>
              </Col>
            </Row>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default DialogModal;



// WEBPACK FOOTER //
// ./src/Components/DialogModal/index.tsx